module.exports = __webpack_public_path__ + "static/media/5-5.871ac956.jpg";